<template>
  <div
    class="trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md"
  >
    <div
      class="trezo-card-header mb-[20px] md:mb-[25px] sm:flex items-center justify-between"
    >
      <div class="trezo-card-title">
        <form class="relative sm:w-[265px]">
          <label
            class="leading-none absolute ltr:left-[13px] rtl:right-[13px] text-black dark:text-white mt-px top-1/2 -translate-y-1/2"
          >
            <i class="material-symbols-outlined !text-[20px]"> search </i>
          </label>
          <input
            type="text"
            v-model="searchQuery"
            :placeholder="directT('todoList.searchTask')"
            class="bg-gray-50 border border-gray-50 h-[36px] text-xs rounded-md w-full block text-black pt-[11px] pb-[12px] ltr:pl-[38px] rtl:pr-[38px] ltr:pr-[13px] ltr:md:pr-[16px] rtl:pl-[13px] rtl:md:pl-[16px] placeholder:text-gray-500 outline-0 dark:bg-[#15203c] dark:text-white dark:border-[#15203c] dark:placeholder:text-gray-400"
          />
        </form>
      </div>
      <div class="trezo-card-subtitle mt-[15px] sm:mt-0">
        <button
          type="button"
          class="inline-block transition-all rounded-md font-medium px-[13px] py-[6px] text-primary-500 border border-primary-500 hover:bg-primary-500 hover:text-white"
          @click="openTaskModal(null)"
        >
          <span class="inline-block relative ltr:pl-[22px] rtl:pr-[22px]">
            <i
              class="material-symbols-outlined !text-[22px] absolute ltr:-left-[4px] rtl:-right-[4px] top-1/2 -translate-y-1/2"
            >
              add
            </i>
            {{ directT('todoList.addNewTask') }}
          </span>
        </button>
      </div>
    </div>

    <div class="trezo-card-content -mx-[20px] md:-mx-[25px]">
      <div v-if="loading" class="text-center py-5">
        <div class="inline-block animate-spin rounded-full border-4 border-primary-500 border-t-transparent h-12 w-12 mb-4"></div>
        <p class="text-gray-500 dark:text-gray-400">{{ directT('todoList.loading') }}</p>
      </div>
      <div v-else-if="errorMessage" class="text-center py-5 text-danger-500">
        {{ errorMessage }}
      </div>
      <div v-else-if="filteredTasks.length === 0" class="text-center py-5">
        <p class="text-gray-500 dark:text-gray-400">{{ directT('todoList.noTasksFound') }}</p>
      </div>
      <div v-else class="table-responsive overflow-x-auto">
        <table class="w-full without-border">
          <thead class="text-black dark:text-white">
            <tr>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                <div class="form-check relative top-[2px]">
                  <input type="checkbox" class="cursor-pointer" />
                </div>
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('todoList.id') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('todoList.taskTitle') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('todoList.assignedTo') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('todoList.dueDate') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('todoList.priority') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('todoList.status') }}
              </th>
              <th
                class="font-medium ltr:text-left rtl:text-right px-[20px] py-[11px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 bg-primary-50 dark:bg-[#15203c] whitespace-nowrap"
              >
                {{ directT('todoList.action') }}
              </th>
            </tr>
          </thead>
          <tbody class="text-black dark:text-white">
            <tr v-for="task in filteredTasks" :key="task.id">
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <div class="form-check relative top-[2px]">
                  <input type="checkbox" class="cursor-pointer" />
                </div>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ task.id?.slice(0, 8) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span
                  class="block font-medium text-gray-500 dark:text-gray-400"
                >
                  {{ task.tasktitle }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                {{ task.assignedName || directT('todoList.notAssigned') }}
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ formatDate(task.duedate) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span class="text-gray-500 dark:text-gray-400">
                  {{ getLocalizedPriority(task.priority || 'medium') }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <span
                  :class="getStatusClass(task.status)"
                >
                  {{ getLocalizedStatus(task.status) }}
                </span>
              </td>
              <td
                class="ltr:text-left rtl:text-right whitespace-nowrap px-[20px] py-[17px] md:ltr:first:pl-[25px] md:rtl:first:pr-[25px] ltr:first:pr-0 rtl:first:pl-0 border-b border-gray-100 dark:border-[#172036]"
              >
                <div class="flex items-center gap-[9px]">
                  <button
                    type="button"
                    class="text-primary-500 leading-none custom-tooltip"
                    v-tooltip="directT('todoList.view')"
                    @click="viewTask(task)"
                  >
                    <i class="material-symbols-outlined !text-md">
                      visibility
                    </i>
                  </button>
                  <button
                    type="button"
                    class="text-gray-500 dark:text-gray-400 leading-none custom-tooltip"
                    v-tooltip="directT('todoList.edit')"
                    @click="openTaskModal(task)"
                  >
                    <i class="material-symbols-outlined !text-md"> edit </i>
                  </button>
                  <button
                    type="button"
                    class="text-danger-500 leading-none custom-tooltip"
                    v-tooltip="directT('todoList.delete')"
                    @click="deleteTask(task)"
                  >
                    <i class="material-symbols-outlined !text-md"> delete </i>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- Task Modal -->
    <div v-if="showTaskModal" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white dark:bg-[#0c1427] p-5 rounded-md w-full max-w-md">
        <h2 class="text-lg font-semibold mb-4">{{ editingTask ? directT('todoList.editTask') : directT('todoList.addTask') }}</h2>
        
        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">{{ directT('todoList.taskTitle') }}</label>
          <input 
            type="text" 
            v-model="taskForm.tasktitle"
            class="w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
          />
        </div>
        
        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">{{ directT('todoList.dueDate') }}</label>
          <input 
            type="date" 
            v-model="taskForm.duedate"
            class="w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
          />
        </div>
        
        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">{{ directT('todoList.assignedTo') }}</label>
          <select 
            v-model="taskForm.assignedto"
            class="w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
          >
            <option value="">{{ directT('todoList.notAssigned') }}</option>
            <option v-for="user in users" :key="user.id" :value="user.id">
              {{ user.email }}
            </option>
          </select>
        </div>
        
        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">{{ directT('todoList.priority') }}</label>
          <select 
            v-model="taskForm.priority"
            class="w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
          >
            <option value="high">{{ directT('todoList.high') }}</option>
            <option value="medium">{{ directT('todoList.medium') }}</option>
            <option value="low">{{ directT('todoList.low') }}</option>
          </select>
        </div>
        
        <div class="mb-3">
          <label class="block text-sm font-medium mb-1">{{ directT('todoList.status') }}</label>
          <select 
            v-model="taskForm.status"
            class="w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
          >
            <option value="pending">{{ directT('todoList.pending') }}</option>
            <option value="in_progress">{{ directT('todoList.inProgress') }}</option>
            <option value="completed">{{ directT('todoList.completed') }}</option>
            <option value="cancelled">{{ directT('todoList.cancelled') }}</option>
          </select>
        </div>
        
        <div class="mb-4">
          <label class="block text-sm font-medium mb-1">{{ directT('todoList.description') }}</label>
          <textarea 
            v-model="taskForm.description"
            rows="3"
            class="w-full p-2 border rounded dark:bg-[#15203c] dark:border-[#172036]"
          ></textarea>
        </div>
        
        <div class="flex justify-end space-x-2">
          <button 
            @click="closeTaskModal"
            class="px-4 py-2 bg-gray-200 dark:bg-[#172036] rounded"
          >
            {{ directT('todoList.cancel') }}
          </button>
          <button 
            @click="saveTask"
            class="px-4 py-2 bg-primary-500 text-white rounded"
            :disabled="saveLoading"
          >
            <span v-if="saveLoading">{{ directT('todoList.saving') }}</span>
            <span v-else>{{ directT('todoList.save') }}</span>
          </button>
        </div>
      </div>
    </div>
    
    <!-- View Task Modal -->
    <div v-if="showViewModal && viewingTask" class="fixed inset-0 flex items-center justify-center z-50 bg-black bg-opacity-50">
      <div class="bg-white dark:bg-[#0c1427] p-5 rounded-md w-full max-w-md">
        <h2 class="text-lg font-semibold mb-4">{{ directT('todoList.details') }}</h2>
        
        <div class="mb-3">
          <span class="block text-sm font-medium">{{ directT('todoList.id') }}:</span>
          <span>{{ viewingTask.id }}</span>
        </div>
        
        <div class="mb-3">
          <span class="block text-sm font-medium">{{ directT('todoList.title') }}:</span>
          <span>{{ viewingTask.tasktitle }}</span>
        </div>
        
        <div class="mb-3">
          <span class="block text-sm font-medium">{{ directT('todoList.assignedTo') }}:</span>
          <span>{{ viewingTask.assignedName || directT('todoList.notAssigned') }}</span>
        </div>
        
        <div class="mb-3">
          <span class="block text-sm font-medium">{{ directT('todoList.dueDate') }}:</span>
          <span>{{ formatDate(viewingTask.duedate) }}</span>
        </div>
        
        <div class="mb-3">
          <span class="block text-sm font-medium">{{ directT('todoList.priority') }}:</span>
          <span>{{ getLocalizedPriority(viewingTask.priority || 'medium') }}</span>
        </div>
        
        <div class="mb-3">
          <span class="block text-sm font-medium">{{ directT('todoList.status') }}:</span>
          <span>{{ getLocalizedStatus(viewingTask.status) }}</span>
        </div>
        
        <div class="mb-4" v-if="viewingTask.description">
          <span class="block text-sm font-medium">{{ directT('todoList.description') }}:</span>
          <p class="mt-1">{{ viewingTask.description }}</p>
        </div>
        
        <div class="flex justify-end">
          <button 
            @click="closeViewModal"
            class="px-4 py-2 bg-gray-200 dark:bg-[#172036] rounded"
          >
            {{ directT('todoList.close') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, onMounted } from "vue";
import { supabase } from "@/utils/supabase";
import { useI18n } from "vue-i18n";
import enTranslations from "@/i18n/locales/en.json";
import heTranslations from "@/i18n/locales/he.json";
import arTranslations from "@/i18n/locales/ar.json";

interface Task {
  id?: string;
  userid?: string;
  tasktitle: string;
  assignedto?: string;
  assignedName?: string;
  duedate?: string;
  priority?: 'high' | 'medium' | 'low';
  status: 'pending' | 'in_progress' | 'completed' | 'cancelled';
  description?: string;
  created_at?: string;
  updated_at?: string;
}

// Type definition for translation objects
type TranslationObject = {
  [key: string]: string | TranslationObject;
};

export default defineComponent({
  name: "ToDoList",
  setup() {
    const tasks = ref<Task[]>([]);
    const loading = ref(true);
    const errorMessage = ref("");
    const searchQuery = ref("");
    const users = ref<{id: string, email: string}[]>([]);
    
    const showTaskModal = ref(false);
    const showViewModal = ref(false);
    const editingTask = ref<Task | null>(null);
    const viewingTask = ref<Task | null>(null);
    const saveLoading = ref(false);
    
    // i18n
    const { locale } = useI18n();
    
    // Translation files
    const translationFiles = {
      en: enTranslations,
      he: heTranslations,
      ar: arTranslations
    };
    
    // Direct translation function that bypasses vue-i18n
    const directT = (key: string): string => {
      const parts = key.split('.');
      let result: TranslationObject = translationFiles[locale.value as keyof typeof translationFiles];
      
      for (const part of parts) {
        if (!result || !(part in result)) {
          console.warn(`Missing translation key: ${key} in ${locale.value} locale`);
          // Fallback to English if translation not found
          let enResult: TranslationObject = translationFiles.en;
          for (const fallbackPart of parts) {
            if (!enResult || !(fallbackPart in enResult)) return key;
            enResult = enResult[fallbackPart as keyof typeof enResult] as TranslationObject;
          }
          return typeof enResult === 'string' ? enResult : key;
        }
        result = result[part as keyof typeof result] as TranslationObject;
      }
      return typeof result === 'string' ? result : key;
    };
    
    const taskForm = ref<Task>({
      tasktitle: "",
      assignedto: "",
      duedate: "",
      priority: "medium",
      status: "pending",
      description: "",
    });
    
    const fetchTasks = async () => {
      try {
        loading.value = true;
        errorMessage.value = "";
        
        const { data: userData, error: userError } = await supabase.auth.getUser();
        
        if (userError) {
          throw new Error(userError.message);
        }
        
        if (!userData || !userData.user) {
          throw new Error("No authenticated user found");
        }
        
        const { data, error } = await supabase
          .from('todolist')
          .select('*')
          .order('created_at', { ascending: false });
          
        if (error) {
          throw new Error(error.message);
        }
        
        // Get user names for assignedto
        const userIds = data?.filter(task => task.assignedto).map(task => task.assignedto) || [];
        
        if (userIds.length > 0) {
          const { data: usersData, error: usersError } = await supabase
            .from('user_profiles')
            .select('user_id, email, display_name')
            .in('user_id', userIds);
            
          if (!usersError && usersData) {
            const userMap = new Map();
            usersData.forEach(user => {
              // Use display_name if available, otherwise fall back to email
              userMap.set(user.user_id, user.display_name || user.email);
            });
            
            data?.forEach(task => {
              if (task.assignedto && userMap.has(task.assignedto)) {
                task.assignedName = userMap.get(task.assignedto);
              }
            });
          }
        }
        
        tasks.value = data || [];
      } catch (error) {
        console.error("Error fetching tasks:", error);
        errorMessage.value = error instanceof Error ? error.message : "Failed to load tasks";
      } finally {
        loading.value = false;
      }
    };
    
    const filteredTasks = computed(() => {
      if (!searchQuery.value) return tasks.value;
      
      const query = searchQuery.value.toLowerCase();
      return tasks.value.filter(task => 
        task.tasktitle.toLowerCase().includes(query) ||
        (task.description && task.description.toLowerCase().includes(query)) ||
        (task.assignedName && task.assignedName.toLowerCase().includes(query))
      );
    });
    
    const fetchUsers = async () => {
      try {
        // קבלת המשתמש הנוכחי
        const { data: userData, error: userError } = await supabase.auth.getUser();
        if (userError || !userData.user) {
          console.error("Error getting current user:", userError);
          return;
        }
        
        // קבלת פרופיל המשתמש עם ה-org_id
        const { data: profileData, error: profileError } = await supabase
          .from('user_profiles')
          .select('org_id')
          .eq('user_id', userData.user.id)
          .single();
          
        if (profileError || !profileData || !profileData.org_id) {
          console.error("Error getting user's organization:", profileError);
          return;
        }
        
        // שליפת המשתמשים מאותו ארגון
        const { data, error } = await supabase
          .from('user_profiles')
          .select('id, user_id, email, display_name')
          .eq('org_id', profileData.org_id);
          
        if (error) {
          console.error("Error fetching users:", error);
          return;
        }
        
        users.value = data?.map(user => ({
          id: user.user_id,
          email: user.display_name || user.email
        })) || [];
      } catch (error) {
        console.error("Error in fetchUsers:", error);
      }
    };
    
    const openTaskModal = (task: Task | null) => {
      fetchUsers(); // Load users for dropdown
      
      if (task) {
        editingTask.value = task;
        taskForm.value = {
          id: task.id,
          tasktitle: task.tasktitle,
          duedate: task.duedate ? new Date(task.duedate).toISOString().split('T')[0] : "",
          assignedto: task.assignedto || "",
          priority: task.priority || "medium",
          status: task.status,
          description: task.description || "",
          assignedName: task.assignedName
        };
      } else {
        editingTask.value = null;
        taskForm.value = {
          id: "",
          tasktitle: "",
          duedate: "",
          assignedto: "",
          priority: "medium",
          status: "pending",
          description: "",
        };
      }
      showTaskModal.value = true;
    };
    
    const closeTaskModal = () => {
      showTaskModal.value = false;
    };
    
    const viewTask = (task: Task) => {
      viewingTask.value = task;
      showViewModal.value = true;
    };
    
    const closeViewModal = () => {
      showViewModal.value = false;
    };
    
    const saveTask = async () => {
      try {
        saveLoading.value = true;
        
        if (!taskForm.value.tasktitle) {
          throw new Error("Task title is required");
        }
        
        const { data: userData, error: userError } = await supabase.auth.getUser();
        
        if (userError || !userData || !userData.user) {
          throw new Error("Authentication required");
        }
        
        const taskData = {
          tasktitle: taskForm.value.tasktitle,
          duedate: taskForm.value.duedate ? new Date(taskForm.value.duedate).toISOString() : null,
          assignedto: taskForm.value.assignedto || null,
          priority: taskForm.value.priority,
          status: taskForm.value.status,
          description: taskForm.value.description || null,
          assignedName: taskForm.value.assignedName
        };
        
        let newTaskId;
        
        if (editingTask.value) {
          // Update existing task
          const { error } = await supabase
            .from('todolist')
            .update({
              ...taskData,
              updated_at: new Date().toISOString()
            })
            .eq('id', editingTask.value.id);
            
          if (error) throw new Error(error.message);
        } else {
          // Create new task
          const { data, error } = await supabase
            .from('todolist')
            .insert({
              ...taskData,
              userid: userData.user.id
            })
            .select();
            
          if (error) throw new Error(error.message);
          
          // Store the new task ID
          if (data && data.length > 0) {
            newTaskId = data[0].id;
            
            // If task is assigned to someone, create a notification for them
            if (taskData.assignedto) {
              console.log("Task assigned to user, creating notification...");
              try {
                // Create a notification for the assigned user
                const notificationResult = await createNotification(
                  taskData.assignedto,
                  `New task: ${taskData.tasktitle}`
                );
                
                console.log("Notification creation result:", notificationResult);
              } catch (notificationError) {
                console.error("Error creating notification:", notificationError);
                // לא זורקים שגיאה כדי לא לעצור את התהליך
              }
            }
          }
        }
        
        await fetchTasks();
        closeTaskModal();
      } catch (error) {
        console.error("Error saving task:", error);
        errorMessage.value = error instanceof Error ? error.message : "Failed to save task";
      } finally {
        saveLoading.value = false;
      }
    };
    
    // Function to create a notification
    const createNotification = async (userId: string, content: string) => {
      try {
        console.log("Creating notification for user:", userId, "Content:", content);
        
        const notificationData = {
          userid: userId,
          content: content,
          type: 'alert',
          status: 'unread'
          // זמן יתווסף אוטומטית בדאטאבייס דרך ה-created_at
        };
        
        const { data, error } = await supabase
          .from('notifications')
          .insert(notificationData)
          .select();
          
        if (error) {
          console.error("Error creating notification:", error);
          return null;
        }
        
        console.log("Notification created successfully:", data);
        return data;
      } catch (error) {
        console.error("Failed to create notification:", error);
        return null;
      }
    };
    
    const deleteTask = async (task: Task) => {
      if (!confirm(directT('todoList.deleteConfirmation').replace("{task}", task.tasktitle))) {
        return;
      }
      
      try {
        loading.value = true;
        
        const { error } = await supabase
          .from('todolist')
          .delete()
          .eq('id', task.id);
          
        if (error) throw new Error(error.message);
        
        await fetchTasks();
      } catch (error) {
        console.error("Error deleting task:", error);
        errorMessage.value = error instanceof Error ? error.message : "Failed to delete task";
      } finally {
        loading.value = false;
      }
    };
    
    const formatDate = (dateString?: string) => {
      if (!dateString) return 'Not set';
      return new Date(dateString).toLocaleDateString();
    };
    
    const capitalizeFirstLetter = (string: string) => {
      return string.charAt(0).toUpperCase() + string.slice(1);
    };
    
    const getStatusClass = (status: string) => {
      const baseClasses = "px-[8px] py-[3px] inline-block rounded-sm font-medium text-xs";
      
      switch (status) {
        case 'pending':
          return `${baseClasses} bg-warning-50 dark:bg-[#15203c] text-warning-500`;
        case 'in_progress':
          return `${baseClasses} bg-success-50 dark:bg-[#15203c] text-success-500`;
        case 'completed':
          return `${baseClasses} bg-primary-50 dark:bg-[#15203c] text-primary-500`;
        case 'cancelled':
          return `${baseClasses} bg-danger-50 dark:bg-[#15203c] text-danger-500`;
        default:
          return `${baseClasses} bg-warning-50 dark:bg-[#15203c] text-warning-500`;
      }
    };
    
    const getStatusLabel = (status: string) => {
      switch (status) {
        case 'pending':
          return 'Pending';
        case 'in_progress':
          return 'In Progress';
        case 'completed':
          return 'Completed';
        case 'cancelled':
          return 'Cancelled';
        default:
          return 'Pending';
      }
    };
    
    const getLocalizedPriority = (priority: string) => {
      switch (priority) {
        case 'high':
          return directT('todoList.high');
        case 'medium':
          return directT('todoList.medium');
        case 'low':
          return directT('todoList.low');
        default:
          return directT('todoList.medium');
      }
    };
    
    const getLocalizedStatus = (status: string) => {
      switch (status) {
        case 'pending':
          return directT('todoList.pending');
        case 'in_progress':
          return directT('todoList.inProgress');
        case 'completed':
          return directT('todoList.completed');
        case 'cancelled':
          return directT('todoList.cancelled');
        default:
          return directT('todoList.pending');
      }
    };
    
    onMounted(() => {
      fetchTasks();
    });

    return {
      tasks,
      loading,
      errorMessage,
      searchQuery,
      filteredTasks,
      showTaskModal,
      showViewModal,
      editingTask,
      viewingTask,
      taskForm,
      saveLoading,
      users,
      openTaskModal,
      closeTaskModal,
      viewTask,
      closeViewModal,
      saveTask,
      deleteTask,
      formatDate,
      capitalizeFirstLetter,
      getStatusClass,
      getStatusLabel,
      directT,
      getLocalizedPriority,
      getLocalizedStatus
    };
  },
});
</script>
